/*
 *
 * Options actions
 *
 */

import {
  OPTIONS_LOADED,
  LOAD_DATA,
  LOADING_DATA,
  LOADING_ERROR,
  LOAD_PLAN,
  NEW_PLAN,
  SAVE_PLAN,
  PLAN_SAVED,
  PLAN_LOADED,
  PLAN_LOAD_FAILED,
  PLAN_LOADING,
  SELECT_MATERIAL,
  SET_DOUBLE_SIDED,
  SELECT_EXPRESSION,
  SELECT_COVER_PANEL,
  SELECT_EDGE,
  SELECT_WALL_LOCATION,
  SELECT_KITCHEN_ISLAND_WALL_LOCATION,
  SELECT_KITCHEN_ISLAND,
  SET_KITCHEN_ISLAND_MEASUREMENTS,
  SELECT_THICKNESS,
  SELECT_SINK_MATERIAL,
  SELECT_SINK_MODEL,
  SELECT_SINK_FASTENING,
  SELECT_DRAINER_GROOVES,
  CHANGE_SHAPE,
  NO_MATERIAL_CHANGE_SHAPE,
  RESET_PLAN,
  CHANGE_CUTOUTS,
  CHANGE_FREESTANDING_HOBS,
  SET_FREESTANDING_HOB_WIDTH,
  CHANGE_SINGLE_CUTS,
  REVERT_PLAN,
  UNDO_CHOICE,
  PARAMETER_SEEN,
  CHANGE_DOUBLE_CUTS,
  CHANGE_TRIPLE_CUTS,
  CHANGE_HIGH_CABINET_JOINTS,
  CHANGE_ROUNDED_CORNERS,
  CHANGE_INVERTED_CORNERS,
  CHANGE_TAP_HOLES,
  CHANGE_DEFAULT_SHAPE,
  RESET_NUMERICAL_PARAMETER,
  NO_MATERIAL_RESET_NUMERICAL_PARAMETER,
  RESET_WORKTOP_SHAPE_MEASUREMENTS,
  RESET_PREVIOUS_SINK_MODEL,
  SET_SHAPE_FIELD,
  SET_PLAN_NAME,
  SET_PLAN_CODE,
  SELECT_WALL_PANEL_MATERIAL,
  SELECT_NO_MATERIAL_WALL_PANEL_MATERIAL,
  SELECT_WALL_PANEL_EXPRESSION,
  SELECT_SPLASHBACK,
  SELECT_KITCHEN_ISLAND_MATERIAL,
  SELECT_NO_MATERIAL_KITCHEN_ISLAND_MATERIAL,
  SELECT_KITCHEN_ISLAND_EXPRESSION,
  SELECT_KITCHEN_ISLAND_COVER_PANEL,
  SELECT_KITCHEN_ISLAND_EDGE,
  SELECT_KITCHEN_ISLAND_THICKNESS,
  SELECT_KITCHEN_ISLAND_SAME_AS_WORKTOP,
  SELECT_NO_MATERIAL_KITCHEN_ISLAND_SAME_AS_WORKTOP,
  SELECT_KITCHEN_ISLAND_OVERHANG,
  SET_WALL_PANEL_HEIGHT,
  SET_WALL_EDGING_STRIP_HEIGHT,
  CHANGE_WALL_PANEL_ROUND_CUTS_SMALL,
  CHANGE_WALL_PANEL_ROUND_CUTS_BIG,
  CHANGE_WALL_PANEL_SQUARE_CUTS,
  CHANGE_WALL_PANEL_SINGLE_CUTS,
  CHANGE_WALL_PANEL_DOUBLE_CUTS,
  CHANGE_WALL_PANEL_TRIPLE_CUTS,
  CHECK_FOR_NEW_FEATURES,
  SELECT_OVERHANG,
  SELECT_OVERHANG_SIDE,
  SELECT_NO_MATERIAL_OVERHANG,
  SET_OVERHANG_FIELD,
  SELECT_WALL_PANEL_MATCH_WORKTOP,
  SELECT_NO_MATERIAL_WALL_PANEL_MATCH_WORKTOP,
  SET_KITCHEN_ISLAND_DOUBLE_SIDED,
  SELECT_KITCHEN_ISLAND_SPLASH_BACK,
  SELECT_KITCHEN_ISLAND_OVERHANG_SIDE,
  SET_KITCHEN_ISLAND_OVERHANG_FIELD,
  CHANGE_KITCHEN_ISLAND_SINGLE_CUTS,
  CHANGE_KITCHEN_ISLAND_ROUNDED_CORNERS,
  CHANGE_KITCHEN_ISLAND_SQUARE_CUTS,
  SELECT_WALL_EDGING_STRIP_MATERIAL,
  SELECT_WALL_EDGING_STRIP_CUSTOMIZABLE_MATERIAL,
  SELECT_APPOINTMENT_BOOKING_CARD,
} from './constants';

import {
  material,
  expression,
  edge,
  thickness,
  splashback,
  sinkMaterial,
  sinkModel,
  sinkFastening,
  drainerGrooves,
  cutout,
  roundedCorner,
  invertedCorner,
  singleCut,
  doubleCut,
  tripleCut,
  highCabinetJoint,
  tapHole,
  wallPanelRoundCutSmall,
  wallPanelRoundCutBig,
  wallPanelSquareCut,
  wallPanelSingleCut,
  wallPanelDoubleCut,
  wallPanelTripleCut,
  kitchenIslandMaterial,
  kitchenIslandExpression,
  kitchenIslandEdge,
  kitchenIslandThickness,
  overhangSide,
  freestandingHob,
  kitchenIslandSingleCut,
  kitchenIslandRoundedCorner,
  kitchenIslandSquareCut,
} from './planParameters';

export function optionsLoaded(options, country, language) {
  return {
    type: OPTIONS_LOADED,
    options,
    country,
    language,
  };
}

export function loadPlan(code, fromLink, fromLocalStorage = false) {
  return {
    type: LOAD_PLAN,
    code,
    fromLink,
    fromLocalStorage,
  };
}

export function newPlan() {
  return {
    type: NEW_PLAN,
  };
}

export function savePlan(redirect = true, showPlanSavedDialog = true, upptackaSave = false) {
  return {
    type: SAVE_PLAN,
    redirect,
    showPlanSavedDialog,
    upptackaSave,
  };
}

export function planSaved(code, name) {
  return {
    type: PLAN_SAVED,
    code,
    name,
  };
}

export function setPlanName(name) {
  return {
    type: SET_PLAN_NAME,
    name,
  };
}

export function setPlanCode(code) {
  return {
    type: SET_PLAN_CODE,
    code,
  };
}

export function planLoaded(plan, hasChanges = false, code, updateLastOpened = true) {
  return {
    type: PLAN_LOADED,
    plan,
    hasChanges,
    code,
    updateLastOpened,
  };
}

export function planLoadFailed(errorText) {
  return {
    type: PLAN_LOAD_FAILED,
    errorText,
  };
}

export function planLoading(loading) {
  return {
    type: PLAN_LOADING,
    loading,
  };
}

export function loadData(country, language) {
  return {
    type: LOAD_DATA,
    country,
    language,
  };
}

export function selectMaterial(materialId) {
  return {
    type: SELECT_MATERIAL,
    materialId,
  };
}

export function selectExpression(expressionId) {
  return {
    type: SELECT_EXPRESSION,
    expressionId,
  };
}

export function selectCoverPanel(coverPanelId) {
  return {
    type: SELECT_COVER_PANEL,
    coverPanelId,
  };
}

export function selectEdge(edgeId) {
  return {
    type: SELECT_EDGE,
    edgeId,
  };
}

export function selectWallLocation(wallLocationId) {
  return {
    type: SELECT_WALL_LOCATION,
    wallLocationId,
  };
}

export function selectKitchenIslandWallLocation(wallLocationId) {
  return {
    type: SELECT_KITCHEN_ISLAND_WALL_LOCATION,
    wallLocationId,
  };
}

export function selectKitchenIsland(kitchenIslandId, flipped = false) {
  return {
    type: SELECT_KITCHEN_ISLAND,
    kitchenIslandId,
    flipped,
  };
}

export function selectKitchenIslandMaterial(materialId) {
  return {
    type: SELECT_KITCHEN_ISLAND_MATERIAL,
    materialId,
  };
}

export function selectNoMaterialKitchenIslandMaterial(materialId) {
  return {
    type: SELECT_NO_MATERIAL_KITCHEN_ISLAND_MATERIAL,
    materialId,
  };
}

export function selectKitchenIslandExpression(expressionId) {
  return {
    type: SELECT_KITCHEN_ISLAND_EXPRESSION,
    expressionId,
  };
}

export function selectKitchenIslandCoverPanel(coverPanelId) {
  return {
    type: SELECT_KITCHEN_ISLAND_COVER_PANEL,
    coverPanelId,
  };
}

export function selectKitchenIslandEdge(edgeId) {
  return {
    type: SELECT_KITCHEN_ISLAND_EDGE,
    edgeId,
  };
}

export function selectKitchenIslandThickness(thicknessId) {
  return {
    type: SELECT_KITCHEN_ISLAND_THICKNESS,
    thicknessId,
  };
}

export function selectKitchenIslandOverhang(overhangId) {
  return {
    type: SELECT_KITCHEN_ISLAND_OVERHANG,
    overhangId,
  };
}

export function selectKitchenIslandOverhangSide(overhangSideId) {
  return {
    type: SELECT_KITCHEN_ISLAND_OVERHANG_SIDE,
    overhangSideId,
  };
}

export function selectOverhang(overhangId) {
  return {
    type: SELECT_OVERHANG,
    overhangId,
  };
}

export function selectNoMaterialOverhang(overhangId) {
  return {
    type: SELECT_NO_MATERIAL_OVERHANG,
    overhangId,
  };
}

export function selectOverhangSide(sideId) {
  return {
    type: SELECT_OVERHANG_SIDE,
    sideId,
  };
}

export function setOverhangField(field, value) {
  return {
    type: SET_OVERHANG_FIELD,
    field,
    value,
  };
}

export function setDoubleSided() {
  return {
    type: SET_DOUBLE_SIDED,
  };
}

export function setKitchenIslandMeasurements(field, value) {
  return {
    type: SET_KITCHEN_ISLAND_MEASUREMENTS,
    field,
    value,
  };
}

export function setKitchenIslandOverhangField(field, value) {
  return {
    type: SET_KITCHEN_ISLAND_OVERHANG_FIELD,
    field,
    value,
  };
}

export function selectKitchenIslandSameAsWorktop(sameAsWorktop) {
  return {
    type: SELECT_KITCHEN_ISLAND_SAME_AS_WORKTOP,
    sameAsWorktop,
  };
}

export function selectNoMaterialKitchenIslandSameAsWorktop(sameAsWorktop) {
  return {
    type: SELECT_NO_MATERIAL_KITCHEN_ISLAND_SAME_AS_WORKTOP,
    sameAsWorktop,
  };
}

export function setKitchenIslandDoubleSided() {
  return {
    type: SET_KITCHEN_ISLAND_DOUBLE_SIDED,
  };
}

export function selectKitchenIslandSplashBack() {
  return {
    type: SELECT_KITCHEN_ISLAND_SPLASH_BACK,
  };
}

export function selectWallPanelMatchWorktop(matchWorktop) {
  return {
    type: SELECT_WALL_PANEL_MATCH_WORKTOP,
    matchWorktop,
  };
}

export function selectNoMaterialWallPanelMatchWorktop(matchWorktop) {
  return {
    type: SELECT_NO_MATERIAL_WALL_PANEL_MATCH_WORKTOP,
    matchWorktop,
  };
}

export function selectThickness(thicknessId) {
  return {
    type: SELECT_THICKNESS,
    thicknessId,
  };
}

export function selectSplashback(splashbackId) {
  return {
    type: SELECT_SPLASHBACK,
    splashbackId,
  };
}

export function setWallPanelHeight(height) {
  return {
    type: SET_WALL_PANEL_HEIGHT,
    height,
  };
}

export function setWallEdgingStripHeight(height) {
  return {
    type: SET_WALL_EDGING_STRIP_HEIGHT,
    height,
  };
}

export function selectWallPanelMaterial(materialId) {
  return {
    type: SELECT_WALL_PANEL_MATERIAL,
    materialId,
  };
}

export function selectWallEdgingStripMaterial(materialId) {  
  return {
    type: SELECT_WALL_EDGING_STRIP_MATERIAL,
    materialId,
  };
}

export function selectWallEdgingStripCustomizableMaterial(materialId) {  
  return {
    type: SELECT_WALL_EDGING_STRIP_CUSTOMIZABLE_MATERIAL,
    materialId,
  };
}

export function selectNoMaterialWallPanelMaterial(materialId) {
  return {
    type: SELECT_NO_MATERIAL_WALL_PANEL_MATERIAL,
    materialId,
  };
}

export function selectWallPanelExpression(expressionId) {
  return {
    type: SELECT_WALL_PANEL_EXPRESSION,
    expressionId,
  };
}

export function selectSinkMaterial(sinkMaterialId) {
  return {
    type: SELECT_SINK_MATERIAL,
    sinkMaterialId,
  };
}

export function selectSinkModel(sinkModelId) {
  return {
    type: SELECT_SINK_MODEL,
    sinkModelId,
  };
}

export function selectSinkFastening(sinkFasteningId) {
  return {
    type: SELECT_SINK_FASTENING,
    sinkFasteningId,
  };
}

export function selectDrainerGrooves(drainerGroovesId) {
  return {
    type: SELECT_DRAINER_GROOVES,
    drainerGroovesId,
  };
}

export function loadingData(loading) {
  return {
    type: LOADING_DATA,
    loading,
  };
}

export function loadingError(error) {
  return {
    type: LOADING_ERROR,
    error,
  };
}

export function changeShape(shapeId, measurements, flipped = false, fromItemNo = false, changedMeasurement) {
  return {
    type: CHANGE_SHAPE,
    shapeId,
    measurements,
    flipped,
    fromItemNo,     // set when loading from PIP itemNo
    changedMeasurement
  };
}

export function noMaterialChangeShape(shapeId, measurements, flipped = false, fromItemNo = false) {
  return {
    type: NO_MATERIAL_CHANGE_SHAPE,
    shapeId,
    measurements,
    flipped,
    fromItemNo,     // set when loading from PIP itemNo
  };
}

export function changeDefaultShape(shapeId, measurements) {
  return {
    type: CHANGE_DEFAULT_SHAPE,
    shapeId,
    measurements,
  };
}

export function resetPlan() {
  return {
    type: RESET_PLAN,
  };
}

export function resetWorktopShapeMeasurements(shapeId) {
  return {
    type: RESET_WORKTOP_SHAPE_MEASUREMENTS,
    shapeId,
  };
}

export function resetPreviousSinkModel() {
  return {
    type: RESET_PREVIOUS_SINK_MODEL,
  };
}

export function changeCutouts(amount) {
  return {
    type: CHANGE_CUTOUTS,
    amount,
  };
}

export function changeFreestandingHobs(amount) {
  return {
    type: CHANGE_FREESTANDING_HOBS,
    amount,
  };
}

export function setFreestandingHobWidth(width) {
  return {
    type: SET_FREESTANDING_HOB_WIDTH,
    width,
  };
}

export function changeSingleCuts(amount) {
  return {
    type: CHANGE_SINGLE_CUTS,
    amount,
  };
}

export function changeDoubleCuts(amount) {
  return {
    type: CHANGE_DOUBLE_CUTS,
    amount,
  };
}

export function changeTripleCuts(amount) {
  return {
    type: CHANGE_TRIPLE_CUTS,
    amount,
  };
}

export function changeHighCabinetJoints(amount) {
  return {
    type: CHANGE_HIGH_CABINET_JOINTS,
    amount,
  };
}

export function changeRoundedCorners(amount) {
  return {
    type: CHANGE_ROUNDED_CORNERS,
    amount,
  };
}

export function changeInvertedCorners(amount) {
  return {
    type: CHANGE_INVERTED_CORNERS,
    amount,
  };
}

export function changeWallPanelRoundCutsSmall(amount) {
  return {
    type: CHANGE_WALL_PANEL_ROUND_CUTS_SMALL,
    amount,
  };
}

export function changeWallPanelRoundCutsBig(amount) {
  return {
    type: CHANGE_WALL_PANEL_ROUND_CUTS_BIG,
    amount,
  };
}

export function changeWallPanelSquareCuts(amount) {
  return {
    type: CHANGE_WALL_PANEL_SQUARE_CUTS,
    amount,
  };
}

export function changeWallPanelSingleCuts(amount) {
  return {
    type: CHANGE_WALL_PANEL_SINGLE_CUTS,
    amount,
  };
}

export function changeWallPanelDoubleCuts(amount) {
  return {
    type: CHANGE_WALL_PANEL_DOUBLE_CUTS,
    amount,
  };
}

export function changeWallPanelTripleCuts(amount) {
  return {
    type: CHANGE_WALL_PANEL_TRIPLE_CUTS,
    amount,
  };
}

export function changeKitchenIslandSingleCuts(amount) {
  return {
    type: CHANGE_KITCHEN_ISLAND_SINGLE_CUTS,
    amount,
  };
}

export function changeKitchenIslandRoundedCorners(amount) {
  return {
    type: CHANGE_KITCHEN_ISLAND_ROUNDED_CORNERS,
    amount,
  };
}

export function changeKitchenIslandSquareCuts(amount) {
  return {
    type: CHANGE_KITCHEN_ISLAND_SQUARE_CUTS,
    amount,
  };
}

export function changeTapHoles(amount) {
  return {
    type: CHANGE_TAP_HOLES,
    amount,
  };
}

function parameterSeen(parameter, id) {
  return {
    type: PARAMETER_SEEN,
    parameter,
    id,
  };
}

export function materialSeen(id) {
  return parameterSeen(material, id);
}

export function expressionSeen(id) {
  return parameterSeen(expression, id);
}

export function edgeSeen(id) {
  return parameterSeen(edge, id);
}

export function splashbackSeen(id) {
  return parameterSeen(splashback, id);
}

export function thicknessSeen(id) {
  return parameterSeen(thickness, id);
}

export function sinkMaterialSeen(id) {
  return parameterSeen(sinkMaterial, id);
}

export function sinkModelSeen(id) {
  return parameterSeen(sinkModel, id);
}

export function sinkFasteningSeen(id) {
  return parameterSeen(sinkFastening, id);
}

export function drainerGroovesSeen(id) {
  return parameterSeen(drainerGrooves, id);
}

export function kitchenIslandMaterialSeen(id) {
  return parameterSeen(kitchenIslandMaterial, id);
}

export function kitchenIslandExpressionSeen(id) {
  return parameterSeen(kitchenIslandExpression, id);
}
export function kitchenIslandCoverPanelSeen(id) {
  return parameterSeen(kitchenIslandExpression, id);
}

export function kitchenIslandEdgeSeen(id) {
  return parameterSeen(kitchenIslandEdge, id);
}

export function kitchenIslandThicknessSeen(id) {
  return parameterSeen(kitchenIslandThickness, id);
}

export function overhangSideSeen(id) {
  return parameterSeen(overhangSide, id);
}

export function cutoutsSeen() {
  return parameterSeen(cutout);
}

export function roundedCornersSeen() {
  return parameterSeen(roundedCorner);
}

export function invertedCornersSeen() {
  return parameterSeen(invertedCorner);
}

export function singleCutsSeen() {
  return parameterSeen(singleCut);
}

export function doubleCutsSeen() {
  return parameterSeen(doubleCut);
}

export function tripleCutsSeen() {
  return parameterSeen(tripleCut);
}

export function highCabinetJointsSeen() {
  return parameterSeen(highCabinetJoint);
}

export function tapHolesSeen() {
  return parameterSeen(tapHole);
}

export function wallPanelRoundCutsSmallSeen() {
  return parameterSeen(wallPanelRoundCutSmall);
}

export function wallPanelRoundCutsBigSeen() {
  return parameterSeen(wallPanelRoundCutBig);
}

export function wallPanelSquareCutsSeen() {
  return parameterSeen(wallPanelSquareCut);
}

export function wallPanelSingleCutsSeen() {
  return parameterSeen(wallPanelSingleCut);
}

export function wallPanelDoubleCutsSeen() {
  return parameterSeen(wallPanelDoubleCut);
}

export function wallPanelTripleCutsSeen() {
  return parameterSeen(wallPanelTripleCut);
}

export function kitchenIslandSingleCutSeen() {
  return parameterSeen(kitchenIslandSingleCut);
}

export function kitchenIslandRoundedCornerSeen() {
  return parameterSeen(kitchenIslandRoundedCorner);
}

export function kitchenIslandSquareCutSeen() {
  return parameterSeen(kitchenIslandSquareCut);
}

function resetNumericalParameter(parameter) {
  return {
    type: RESET_NUMERICAL_PARAMETER,
    parameter,
  };
}

function noMaterialresetNumericalParameter(parameter) {
  return {
    type: NO_MATERIAL_RESET_NUMERICAL_PARAMETER,
    parameter,
  };
}

export function resetCutouts() {
  return resetNumericalParameter(cutout);
}

export function noMaterialresetCutouts() {
  return noMaterialresetNumericalParameter(cutout);
}

export function resetFreestandingHobs() {
  return resetNumericalParameter(freestandingHob);
}

export function noMaterialresetFreestandingHobs() {
  return noMaterialresetNumericalParameter(freestandingHob);
}

export function resetSingleCuts() {
  return resetNumericalParameter(singleCut);
}

export function noMaterialresetSingleCuts() {
  return noMaterialresetNumericalParameter(singleCut);
}

export function resetDoubleCuts() {
  return resetNumericalParameter(doubleCut);
}

export function noMaterialresetDoubleCuts() {
  return noMaterialresetNumericalParameter(doubleCut);
}

export function resetTripleCuts() {
  return resetNumericalParameter(tripleCut);
}

export function noMaterialresetTripleCuts() {
  return noMaterialresetNumericalParameter(tripleCut);
}

export function resetHighCabinetJoints() {
  return resetNumericalParameter(highCabinetJoint);
}

export function noMaterialresetHighCabinetJoints() {
  return noMaterialresetNumericalParameter(highCabinetJoint);
}

export function resetRoundedCorners() {
  return resetNumericalParameter(roundedCorner);
}

export function noMaterialresetRoundedCorners() {
  return noMaterialresetNumericalParameter(roundedCorner);
}

export function resetInvertedCorners() {
  return resetNumericalParameter(invertedCorner);
}

export function noMaterialresetInvertedCorners() {
  return noMaterialresetNumericalParameter(invertedCorner);
}

export function resetTapHoles() {
  return resetNumericalParameter(tapHole);
}

export function noMaterialresetTapHoles() {
  return noMaterialresetNumericalParameter(tapHole);
}

export function resetWallPanelRoundCutsSmall() {
  return resetNumericalParameter(wallPanelRoundCutSmall);
}

export function noMaterialresetWallPanelRoundCutsSmall() {
  return noMaterialresetNumericalParameter(wallPanelRoundCutSmall);
}

export function resetWallPanelRoundCutsBig() {
  return resetNumericalParameter(wallPanelRoundCutBig);
}

export function noMaterialresetWallPanelRoundCutsBig() {
  return noMaterialresetNumericalParameter(wallPanelRoundCutBig);
}

export function resetWallPanelSquareCuts() {
  return resetNumericalParameter(wallPanelSquareCut);
}

export function resetWallPanelSingleCuts() {
  return resetNumericalParameter(wallPanelSingleCut);
}

export function resetWallPanelDoubleCuts() {
  return resetNumericalParameter(wallPanelDoubleCut);
}

export function resetWallPanelTripleCuts() {
  return resetNumericalParameter(wallPanelTripleCut);
}

export function resetKitchenIslandSingleCuts() {
  return resetNumericalParameter(kitchenIslandSingleCut);
}

export function resetKitchenIslandRoundedCorners() {
  return resetNumericalParameter(kitchenIslandRoundedCorner);
}

export function resetKitchenIslandSquareCuts() {
  return resetNumericalParameter(kitchenIslandSquareCut);
}

export function revertPlan() {
  return {
    type: REVERT_PLAN,
  };
}

export function undoChoice() {
  return {
    type: UNDO_CHOICE,
  };
}

export function setShapeField(id, field, value) {
  return {
    type: SET_SHAPE_FIELD,
    id,
    field,
    value,
  };
}

export function checkForNewFeatures() {
  return {
    type: CHECK_FOR_NEW_FEATURES,
  };
}

export function selectAppointmentBooking(pageId) {
  return {
    type: SELECT_APPOINTMENT_BOOKING_CARD,
    pageId,
  };
}
